(function($) {

	'use strict';

	var init = function() {
		resizeIframe();
	};

	var resizeIframe = function() {
	    // Find all YouTube videos
	    var $allPDF = $(".pdf-wrapper iframe"),

	    // The element that is fluid width
	    $fluidEl = $(".content_pdf__item");

		// Figure out and save aspect ratio for each video
		$allPDF.each(function() {
            
            var pdfWidth = this.width;
            var pdfHeight = this.height;
            
            if(pdfWidth == '100%'){
                pdfWidth = $('.pdf-wrapper').outerWidth();
            }

			$(this)
				.attr('data-aspectRatio', pdfHeight / pdfWidth)
				// and remove the hard coded width/height
				.removeAttr('height')
				.removeAttr('width');

		});

		// When the window is resized
		$(window).resize(function() {

			var newWidth = $fluidEl.width();

			// Resize all videos according to their own aspect ratio
			$allPDF.each(function() {

				var $el = $(this);
				$el
					.width(newWidth)
					.height(newWidth * $el.attr('data-aspectRatio'));

			});

		// Kick off one resize to fix all videos on page load
		}).resize();
	};

$(document).ready(function() {
	init();
});

})(jQuery);
